<wl-modal
  (closeModal)="closeModal()"
  [modalTitle]="product()?.content?.longTitle"
>
  <ng-template wlModalBody>
    <div class="d-flex flex-column gap-2">
      <p class="mb-0">
        <strong>+ {{ product()?.price | euroCurrency: '1.0-2' }}</strong>
        {{ content().perMonthLong }}
      </p>
      <p class="mb-0" *wlGenericRichText="product()?.content?.longSubtitle"></p>
      <wl-generic-usps [usps]="usps()" />
      <crnt-button
        variant="primary"
        wlAutomationId="accept-cross-sell-product"
        (click)="selectProduct()"
      >
        {{ content().addProduct }}
      </crnt-button>
      <crnt-button
        variant="tertiary"
        wlAutomationId="reject-cross-sell-product"
        (click)="rejectProduct()"
      >
        {{ content().rejectProduct }}
      </crnt-button>
    </div>
  </ng-template>
</wl-modal>
